module.exports = __webpack_public_path__ + "media/images/home/dollar-9b1341c28aabeb73fc08c1b81c435ebe.png";